export const recaptcha = () => {
    return new Promise(resolve => {
        window.grecaptcha.ready(() => {
            window.grecaptcha.execute(process.env.VUE_APP_RECAPTCHA_SITE_KEY, {action: 'submit'}).then((token) => resolve(token))
        })
    })
}